import { STATUS_LABEL } from "@/lib/api";

export default function StatusBadge({ status, testid, label: labelOverride }) {
  const label = labelOverride || STATUS_LABEL[status] || status;
  return (
    <span className={`badge-status badge-${status}`} data-testid={testid || `status-${status}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {label}
    </span>
  );
}
